import type { AppInputHandlers, AppInputTypeHookOptions } from '../types/interfaces'

const clampValue = (value: number, min?: number, max?: number): number => {
  if (typeof min === 'number' && value < min) return min
  if (typeof max === 'number' && value > max) return max
  return value
}

const sanitizeNumericString = (raw: string): string => {
  if (raw === '') return ''
  return raw.replace(/^0+(\d)/, '$1')
}

export const useAppInputNumber = ({
  model,
  props,
  onKeyupEnter,
}: AppInputTypeHookOptions): AppInputHandlers => {
  const handleInput = (): void => {
    const raw = sanitizeNumericString(String(model.value))

    if (raw === '') {
      model.value = ''
      return
    }

    model.value = clampValue(Number(raw), props.min, props.max)
  }

  const handleChange = (): void => {
    const raw = String(model.value)

    if (raw === '') {
      model.value = ''
      return
    }

    model.value = clampValue(Number(raw), props.min, props.max)
  }

  const handleKeyupEnter = (): void => {
    onKeyupEnter(model.value)
  }

  return {
    handleInput,
    handleChange,
    handleKeyupEnter,
  }
}
